// ==========================
// Version 2 — components/BrandLogo.js
// - Shared BWK logo image mark for nav, landing, footer, and branded empty states
// - Adds an optional framed treatment for nav/hero brand moments
// ==========================
import React from 'react';
import bwkLogo from '../assets/bwk-logo.png';

export default function BrandLogo({
  size = 44,
  alt = 'Blessed with a Kiss logo',
  decorative = false,
  framed = false,
  style = {},
  imageStyle = {},
}) {
  return (
    <span
      aria-hidden={decorative ? 'true' : undefined}
      style={{
        ...styles.frame,
        ...(framed ? styles.framed : {}),
        width: size,
        height: size,
        ...style,
      }}
    >
      <img
        src={bwkLogo}
        alt={decorative ? '' : alt}
        width={size}
        height={size}
        style={{
          ...styles.image,
          ...imageStyle,
        }}
        loading="eager"
        decoding="async"
      />
    </span>
  );
}

const styles = {
  frame: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '0 0 auto',
    lineHeight: 0,
  },
  framed: {
    boxSizing: 'border-box',
    borderRadius: 999,
    padding: 3,
    background: 'rgba(10,26,51,0.62)',
    border: '1px solid rgba(201,164,76,0.42)',
    boxShadow: '0 12px 28px rgba(0,0,0,0.26), 0 0 0 1px rgba(253,252,249,0.08)',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    display: 'block',
  },
};
// ==========================
// End Version 2 — BrandLogo.js
// ==========================
